"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
function getListMenuDomRect(e, listElement) {
    var _a = e.getBoundingClientRect(), eLeft = _a.left, eTop = _a.top, eHeight = _a.height, eWidth = _a.width;
    var listHeight = listElement.getBoundingClientRect().height;
    var padding = 4;
    var width = eWidth;
    var left = eLeft;
    // display listElement at bottom of target element as default
    var top = eTop + eHeight + padding;
    var diff = _1.compareClientRectWithViewport({
        top: top,
        left: left,
        bottom: top + listHeight,
        right: left + width,
    });
    // Display on top if the listElement is exceed the view port
    if (diff.exceedBottom > 0) {
        top = eTop - listHeight - padding;
    }
    return {
        top: top,
        left: left,
        width: width,
    };
}
exports.default = getListMenuDomRect;
//# sourceMappingURL=getListMenuDomRect.js.map